/*
  Cart drawer "(Save €X)" label — Sableau
  ------------------------------------------------------------
  The Essential Cart Drawer already renders a struck-through compare-at
  price and the sale price per line item. This script appends a green
  "(Save €X)" right after the sale price, computed from the two amounts
  that are already on screen, so it works in every market currency
  (EUR, SEK, NOK, DKK, GBP, ...) and re-applies after each drawer re-render.

  Scope: the drawer's own markup via its stable data-essential-cart-element
  hooks (line-item-regular-price / line-item-discounted-price).
*/
(function () {
  if (window.__sbCartSavingsLoaded) return;
  window.__sbCartSavingsLoaded = true;

  var STYLE = '.sb-save{color:#0a8a4a;font-weight:600;font-size:.85em;margin-left:.35em;white-space:nowrap}.sb-worth{color:#0a8a4a}'
    // 4) 23-10 late operator: no Subtotal row (the checkout button shows the amount); Essential's own upsell row gives way to
    //    the add-on card under the line items (5, addonRow).
    + '[data-essential-cart-element="subtotal-wrapper"]{display:none!important}'
    + 'html.sb-has-dup [data-essential-cart-element="upsells-wrapper"]{display:none!important}'
    //    Swipe row: 3 cards + a quarter of the 4th in view, so it reads as swipeable; no colour pick: the bag adds the colour on the photo, only the size is chosen (operator 23-10 evening).
    + '.sb-dup{padding:14px 0 14px 16px;border-top:1px solid #ececec}.sb-dup__t{margin:0 16px 8px 0;font-size:15px;font-weight:700;line-height:1.3;color:#111}'
    + '.sb-dup__r{display:flex;gap:8px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch}.sb-dup__r::-webkit-scrollbar{display:none}'
    + '.sb-dup .tr-card{flex:0 0 calc((100% - 24px) / 3.25);scroll-snap-align:start}.sb-dup .tr-card[hidden]{display:none}'
    + '.sb-dup .tr-card>.tr-card__swatches,.sb-dup .tr-card__media img+img,.sb-dup .tr-card__tags{display:none}'
    + '.sb-dup .tr-card .tr-galoff{top:4px;right:4px;font-size:10px;padding:2px 4px}'
    + '.sb-dup .tr-card__title{margin-top:6px;font-size:12px;line-height:15px;white-space:normal;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}'
    + '.sb-dup .tr-card__price{font-size:13px;line-height:18px;margin:0}.sb-dup .tr-card__price s{font-size:11px;font-weight:400;color:#888}'
    + '.sb-dup .tr-card__add{right:5px;bottom:5px;width:30px;height:30px;padding:5px;background:#111;color:#fff;box-shadow:none}.sb-dup .tr-card__add svg{width:20px;height:20px}'
    + '.sb-dup .tr-card__qa{top:0;display:flex;flex-direction:column;justify-content:center;padding:18px 4px 6px}.sb-dup .tr-card__qa[hidden]{display:none}'
    + '.sb-dup .tr-card__qa p{font-size:10px;line-height:13px;margin:0 0 5px}'
    + '.sb-dup .tr-card__qa .tr-qa__s{gap:3px}.sb-dup .tr-card__qa .tr-qa__s button{min-width:28px;padding:5px 2px;font-size:10px}'
    + '.sb-dup .tr-card__ok{height:32px;font-size:11px;gap:4px}';

  // "€199,99" · "kr 1.113,07" · "1 113,07 kr" · "£85.00" · "SEK 1 158,00"
  var PRICE_RE = /^\s*(?:[^\d\s]{0,4}\s?)?\d[\d.,\s ]*(?:\s?[^\d\s]{0,4})?\s*$/;

  function leafText(el) {
    if (el.children.length) return null;
    var t = (el.textContent || '').replace(/ /g, ' ').trim();
    if (!t || t.length > 24 || !/\d/.test(t) || !PRICE_RE.test(t)) return null;
    return t;
  }

  function parseCents(str) {
    var num = str.replace(/[^\d.,]/g, '');
    var m = num.match(/^(.*?)([.,])(\d{2})$/);
    var intPart = (m ? m[1] : num).replace(/[.,]/g, '');
    var dec = m ? m[3] : '00';
    if (!intPart && !m) return null;
    return { cents: parseInt(intPart || '0', 10) * 100 + parseInt(dec, 10), decSep: m ? m[2] : null };
  }

  function formatLike(sample, cents) {
    var m = sample.match(/^(\D*?)(\d[\d.,\s ]*\d|\d)(\D*)$/);
    if (!m) return null;
    var prefix = m[1], numStr = m[2], suffix = m[3];
    var parsed = parseCents(numStr);
    var decSep = (parsed && parsed.decSep) || (numStr.indexOf(',') >= 0 ? ',' : '.');
    var thouSep = '';
    var head = numStr.replace(/[.,]\d{2}\s*$/, '');
    var t = head.match(/[.,\s ]/);
    if (t) thouSep = t[0];
    var whole = Math.floor(cents / 100);
    var frac = String(cents % 100);
    if (frac.length < 2) frac = '0' + frac;
    var ws = String(whole);
    if (thouSep) ws = ws.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    // Price shown without decimals (HUF, JPY, "kr 854"): label the saving the same way, not "(Save 50.00)".
    if (!(parsed && parsed.decSep) && cents % 100 === 0) return prefix + ws + suffix;
    return prefix + ws + decSep + frac + suffix;
  }

  var ITEM = '[data-essential-cart-element="cart-drawer-item"]';
  var REG = '[data-essential-cart-element="line-item-regular-price"]';
  var DISC = '[data-essential-cart-element="line-item-discounted-price"]';
  var PROPS = '[data-essential-cart-element="line-item-properties"]';

  function apply() {
    // 1) "(Save €X)" after the discounted price of every drawer line item.
    var items = document.querySelectorAll(ITEM);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var reg = item.querySelector(REG);
      var disc = item.querySelector(DISC);
      if (!reg || !disc) continue;
      var regTxt = leafText(reg) || (reg.textContent || '').trim();
      var discTxt = leafText(disc) || (disc.textContent || '').trim();
      var a = parseCents(regTxt), b = parseCents(discTxt);
      var existing = disc.parentElement && disc.parentElement.querySelector(':scope > .sb-save');
      if (!a || !b || a.cents <= b.cents) { if (existing) existing.remove(); continue; }
      var label = formatLike(discTxt, a.cents - b.cents);
      if (!label) continue;
      var text = '(Save ' + label + ')';
      if (existing) { if (existing.textContent !== text) existing.textContent = text; continue; }
      var span = document.createElement('span');
      span.className = 'sb-save';
      span.textContent = text;
      disc.parentElement.insertBefore(span, disc.nextSibling);
    }
    // 2) The "You save" line-item property (added for the checkout) would print here as
    //    grey text under the title; the green label already covers it in the drawer.
    var props = document.querySelectorAll(PROPS);
    for (var j = 0; j < props.length; j++) {
      var p = props[j];
      if (p.__sbHidden) continue;
      if (/You save\s*:/.test(p.textContent || '')) { p.style.display = 'none'; p.__sbHidden = true; }
    }
  }

  // 3) Gift bar (Essential reward texts, ADR 0065, 23-10): Essential shows the default market's text in every market, so the
  //    texts carry hooks. .sb-amt = {remaining_amount}: the EUR store format is bare ("20,05"), so EUR gets a "€" in front.
  //    .sb-worth = "€40" (mystery gift price EUR 39.95): other currencies get 40 x the market rate, rounded up.
  function giftBar() {
    var c = window.Shopify && Shopify.currency, cur = c && c.active, rate = c && parseFloat(c.rate);
    if (!cur) return;
    var amts = document.querySelectorAll('.sb-amt');
    for (var i = 0; i < amts.length; i++) {
      var t = (amts[i].textContent || '').trim();
      var want = t.replace(/[.,]00(?=\D*$)/, '');   // 23-10 evening operator: gift from 119.95, so Gats reads "Add €20 more", not "€20,00"
      if (cur === 'EUR' && want && !/€/.test(want)) want = '€' + want;
      if (want && want !== t) amts[i].textContent = want;
    }
    if (cur === 'EUR' || !rate) return;
    var v = 40 * rate; v = v < 100 ? Math.ceil(v) : Math.ceil(v / 10) * 10;
    var label; try { label = new Intl.NumberFormat('en', { style: 'currency', currency: cur, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(v); } catch (e) { label = v + ' ' + cur; }
    var ws = document.querySelectorAll('.sb-worth');
    for (var j = 0; j < ws.length; j++) if (ws[j].textContent !== label) ws[j].textContent = label;
  }

  // 4) The checkout button reads "Secure checkout · <subtotal>" (operator 23-10, like verascopper.com), bare like the store
  //    format (23-10 late operator: no "€" on the button). The Savings amount does get a "€" ("-€49,95").
  function money(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
  function drawerText() {
    var c = window.Shopify && Shopify.currency;
    if (c && c.active === 'EUR') document.querySelectorAll('[data-essential-cart-element="discount-code-amount"]').forEach(function (a) {
      var t = (a.textContent || '').trim();
      if (t && !/€/.test(t)) a.textContent = t.replace(/^(-?)\s*/, '$1€');
    });
    var btn = document.querySelector('[data-essential-cart-element="cart-drawer-checkout-button-text"]');
    var sub = document.querySelector('[data-essential-cart-element="subtotal-wrapper"] [data-essential-cart-element="cart-drawer-property-value"]');
    if (btn && sub) {
      var base = btn.getAttribute('data-sb-base') || (btn.textContent || '').split(' · ')[0].trim();
      btn.setAttribute('data-sb-base', base);
      var label = base + ' · ' + money(sub.textContent);
      if (btn.textContent !== label) btn.textContent = label;
    }
  }

  // 5) 23-10 late operator: add-on swipe row of collection cards under the line items: bag button, then colour + size, one
  //    tap adds (taps: assets/tr-card.js). Cards come from <template id="sb-dup"> in layout/theme.liquid (visitor's currency);
  //    a card leaves once its piece is in the cart, the row once all are. Essential re-renders the drawer, so this runs on every pass.
  function addonRow() {
    var tpl = document.getElementById('sb-dup');
    var list = document.querySelector('[data-essential-cart-element="cart-drawer-item-list-wrapper"]');
    var row = document.querySelector('.sb-dup');
    if (!tpl || !list) return;
    var items = document.querySelectorAll(ITEM), inCart = '';
    for (var i = 0; i < items.length; i++) inCart += ' ' + (items[i].textContent || '');
    if (!items.length) { if (row) row.remove(); return; }
    if (!row) {
      row = tpl.content.firstElementChild.cloneNode(true);
      row.querySelectorAll('.tr-card__title').forEach(function (a) { a.textContent = a.textContent.replace(/^\s*Sableau\s+/, ''); });
    }
    var cards = row.querySelectorAll('[data-tr-card]'), left = 0;
    for (var j = 0; j < cards.length; j++) {
      var name = (cards[j].querySelector('.tr-card__title') || {}).textContent || '';
      var gone = !!name && inCart.indexOf(name.trim()) > -1;
      if (cards[j].hidden !== gone) cards[j].hidden = gone;
      if (!gone) left++;
    }
    if (!left) { row.remove(); return; }
    if (row.previousElementSibling !== list) list.parentNode.insertBefore(row, list.nextSibling);
  }

  window.__sbCartSavingsApply = apply;

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; try { apply(); } catch (e) {} try { giftBar(); } catch (e) {} try { drawerText(); } catch (e) {} try { addonRow(); } catch (e) {} }, 150);
  }

  function start() {
    var css = document.createElement('style');
    css.textContent = STYLE;
    if (document.getElementById('sb-dup')) document.documentElement.classList.add('sb-has-dup');
    (document.head || document.documentElement).appendChild(css);
    schedule();
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if ((muts[i].addedNodes && muts[i].addedNodes.length) || muts[i].type === 'characterData') { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });  // characterData: Essential updates prices in place
    } catch (e) {}
    // Drawer content is injected late / on open; a few timed passes catch it.
    var n = 0;
    var timer = setInterval(function () { schedule(); if (++n > 20) clearInterval(timer); }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/*
  Het tweede blok ("✅ You save"-regeleigenschap via fetch/XHR-onderschepping, met een
  /variants/{id}.js-rondje vóór élke add-to-cart) is 10-09-2026 verwijderd: het kostte tijd op de knop
  waar de omzet begint, en het dubbelde met het groene label hierboven.

  LET OP (bijgewerkt 12-09-2026): de oude reden erbij — "sinds 02-09 heeft geen enkel product nog een
  compare-at-prijs" — geldt niet meer. Op 10-09 staat compare_at weer op 54 producten (sale-anker, ADR
  0016). Het groene "(Save €X)"-label hierboven doet dus weer écht werk; het is geen dode code. Wie hier
  iets weghaalt omdat "er toch geen kortingen zijn", sloopt een levend label.
*/
